// Stroke icon set ported from the client's design prototype (Fair Doctor.dc.html, `ICN`).
// 24×24 viewBox, drawn with currentColor. Regenerate rather than hand-edit.
type IconElement = ['path' | 'circle' | 'rect', Record<string, string>];

export const iconPaths = {
  grid: [
    ['rect', { x: '3', y: '3', width: '7.5', height: '7.5', rx: '1.6' }],
    ['rect', { x: '13.5', y: '3', width: '7.5', height: '7.5', rx: '1.6' }],
    ['rect', { x: '13.5', y: '13.5', width: '7.5', height: '7.5', rx: '1.6' }],
    ['rect', { x: '3', y: '13.5', width: '7.5', height: '7.5', rx: '1.6' }],
  ],
  bold: [['path', { d: 'M7 4.5h6a3.5 3.5 0 0 1 0 7H7v-7zM7 11.5h7a4 4 0 0 1 0 8H7v-8z' }]],
  italic: [['path', { d: 'M15 4.5h-5M14 19.5H9M13.5 4.5 10.5 19.5' }]],
  list: [
    ['path', { d: 'M9 6.5h11M9 12h11M9 17.5h11' }],
    ['circle', { cx: '4.5', cy: '6.5', r: '1.3' }],
    ['circle', { cx: '4.5', cy: '12', r: '1.3' }],
    ['circle', { cx: '4.5', cy: '17.5', r: '1.3' }],
  ],
  listOrdered: [
    ['path', { d: 'M9 6.5h11M9 12h11M9 17.5h11' }],
    [
      'path',
      { d: 'M4 4.8h1.2v3.6M3.4 15.4h2.4M3.4 15.4c0-1.4 2.3-1.2 2.3.1 0 .9-2.3 1.6-2.3 3h2.5' },
    ],
  ],
  image: [
    ['rect', { x: '3', y: '4.5', width: '18', height: '15', rx: '2.5' }],
    ['circle', { cx: '8.8', cy: '10', r: '1.6' }],
    [
      'path',
      { d: 'm4 17 4.6-4.4a1.6 1.6 0 0 1 2.2 0L15 16.6M13.4 15l2.3-2.2a1.6 1.6 0 0 1 2.2 0L20 15' },
    ],
  ],
  send: [
    ['path', { d: 'M4.5 12 20 4.5 15.5 20l-4-6.3-7-1.7z' }],
    ['path', { d: 'm11.5 13.7 8.5-9.2' }],
  ],
  reply: [
    [
      'path',
      { d: 'M9.5 7.5 4 12l5.5 4.5v-3h4.8A5.7 5.7 0 0 1 20 19v-1.3a6.2 6.2 0 0 0-6.2-6.2H9.5v-4z' },
    ],
  ],
  lock: [
    ['rect', { x: '4.5', y: '10.5', width: '15', height: '9.5', rx: '2.5' }],
    ['path', { d: 'M8 10.5V8a4 4 0 0 1 8 0v2.5' }],
  ],
  bot: [
    ['rect', { x: '4', y: '7', width: '16', height: '12', rx: '3' }],
    ['path', { d: 'M12 7V4M9.5 4h5' }],
    ['path', { d: 'M2 12v3M22 12v3' }],
    ['circle', { cx: '9', cy: '12.5', r: '1' }],
    ['circle', { cx: '15', cy: '12.5', r: '1' }],
    ['path', { d: 'M9.5 16h5' }],
  ],
  usersplus: [
    ['circle', { cx: '9', cy: '8', r: '3.4' }],
    ['path', { d: 'M2.8 20a6.2 6.2 0 0 1 12.4 0' }],
    ['path', { d: 'M19 8.5v5M16.5 11h5' }],
  ],
  history: [
    ['path', { d: 'M3 4.5v5h5' }],
    ['path', { d: 'M3.6 9.4A8.5 8.5 0 1 1 3.9 15' }],
    ['path', { d: 'M12 8v4.3l3 1.7' }],
  ],
  user: [
    ['circle', { cx: '12', cy: '8', r: '3.6' }],
    ['path', { d: 'M5 20a7 7 0 0 1 14 0' }],
  ],
  calendar: [
    ['rect', { x: '3', y: '4.5', width: '18', height: '16', rx: '2.4' }],
    ['path', { d: 'M3 9.5h18M8 3v3.4M16 3v3.4' }],
    ['path', { d: 'M8.4 14.4l2.2 2.2 4.4-4.6' }],
  ],
  map: [
    ['path', { d: 'M9 4 3.6 6.1v13.8L9 17.9l6 2 5.4-2.1V4L15 6 9 4z' }],
    ['path', { d: 'M9 4v13.9M15 6v13.9' }],
  ],
  receipt: [
    [
      'path',
      {
        d: 'M5 3.3v17.4l2-1.3 2 1.3 2-1.3 2 1.3 2-1.3 2 1.3V3.3l-2 1.3-2-1.3-2 1.3-2-1.3-2 1.3-2-1.3z',
      },
    ],
    ['path', { d: 'M8 8.5h8M8 12h8M8 15.5h5' }],
  ],
  ticket: [
    [
      'path',
      {
        d: 'M4 8.5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2 2 2 0 0 0 0 3.7v.6a2 2 0 0 0 0 3.7 2 2 0 0 1-2 2H6a2 2 0 0 1-2-2 2 2 0 0 0 0-3.7v-.6A2 2 0 0 0 4 8.5z',
      },
    ],
    ['path', { d: 'M14 6.8v10.4' }],
  ],
  message: [
    [
      'path',
      {
        d: 'M4.5 5h15a1.5 1.5 0 0 1 1.5 1.5V15a1.5 1.5 0 0 1-1.5 1.5H10l-4.5 3.5V16.5H4.5A1.5 1.5 0 0 1 3 15V6.5A1.5 1.5 0 0 1 4.5 5z',
      },
    ],
    ['path', { d: 'M7.5 9.5h9M7.5 12.5h5' }],
  ],
  search: [
    ['circle', { cx: '11', cy: '11', r: '7' }],
    ['path', { d: 'M21 21l-4.3-4.3' }],
  ],
  bell: [
    ['path', { d: 'M6 9.5a6 6 0 0 1 12 0c0 4.5 2 5.5 2 5.5H4s2-1 2-5.5z' }],
    ['path', { d: 'M10 19.5a2.2 2.2 0 0 0 4 0' }],
  ],
  sun: [
    ['circle', { cx: '12', cy: '12', r: '4' }],
    [
      'path',
      {
        d: 'M12 2.5v2.4M12 19.1v2.4M2.5 12h2.4M19.1 12h2.4M5.1 5.1l1.7 1.7M17.2 17.2l1.7 1.7M18.9 5.1l-1.7 1.7M6.8 17.2l-1.7 1.7',
      },
    ],
  ],
  moon: [['path', { d: 'M20.5 13.2A8.5 8.5 0 0 1 10.8 3.5 7 7 0 1 0 20.5 13.2z' }]],
  arrowLeft: [['path', { d: 'M20 12H4.5M10.5 5.5 4 12l6.5 6.5' }]],
  chevronL: [['path', { d: 'M14.5 6 8.5 12l6 6' }]],
  chevronR: [['path', { d: 'M9.5 6l6 6-6 6' }]],
  chevronsL: [['path', { d: 'M11 6 5 12l6 6M18 6l-6 6 6 6' }]],
  chevronsR: [['path', { d: 'M13 6l6 6-6 6M6 6l6 6-6 6' }]],
  menu: [['path', { d: 'M4 6h16M4 12h16M4 18h16' }]],
  download: [
    ['path', { d: 'M12 4v11M7.5 10.5 12 15l4.5-4.5' }],
    ['path', { d: 'M4.5 20h15' }],
  ],
  columns: [
    ['rect', { x: '3', y: '4.5', width: '18', height: '15', rx: '2' }],
    ['path', { d: 'M9 4.5v15M15 4.5v15' }],
  ],
  chart: [
    ['path', { d: 'M4 4v16h16' }],
    ['rect', { x: '7.5', y: '11', width: '2.6', height: '6', rx: '1' }],
    ['rect', { x: '12', y: '7.5', width: '2.6', height: '9.5', rx: '1' }],
    ['rect', { x: '16.5', y: '13.5', width: '2.6', height: '3.5', rx: '1' }],
  ],
  trend: [
    ['path', { d: 'M4 15l5-5 3.5 3.5L20 6' }],
    ['path', { d: 'M15 6h5v5' }],
  ],
  table: [
    ['rect', { x: '3.5', y: '4.5', width: '17', height: '15', rx: '2' }],
    ['path', { d: 'M3.5 9.5h17M3.5 14.5h17M9 9.5v10' }],
  ],
  x: [['path', { d: 'M6 6l12 12M18 6 6 18' }]],
  expand: [['path', { d: 'M14.5 4H20v5.5M20 4l-6.5 6.5M9.5 20H4v-5.5M4 20l6.5-6.5' }]],
  check: [['path', { d: 'M5 12.5 9.5 17 19 7' }]],
  tooth: [
    [
      'path',
      {
        d: 'M12 4c2-1.6 5.5-1.6 6.5 1.5.9 2.8-.4 5.2-1 8-.5 2.3-.6 5.5-2 5.5s-1.4-3.5-3.5-3.5S8.9 19 7.5 19s-1.5-3.2-2-5.5c-.6-2.8-1.9-5.2-1-8C5.5 2.4 10 2.4 12 4z',
      },
    ],
  ],
  users3: [
    ['circle', { cx: '9', cy: '8.5', r: '3' }],
    ['path', { d: 'M3.5 19a5.5 5.5 0 0 1 11 0' }],
    ['path', { d: 'M16 6.2a3 3 0 0 1 0 5.6M17.5 19a5.5 5.5 0 0 0-3-4.9' }],
  ],
  alert: [
    ['path', { d: 'M12 4 3 19.5h18L12 4z' }],
    ['path', { d: 'M12 10v4M12 17h.01' }],
  ],
  loss: [
    ['path', { d: 'M4 7l5 5 3.5-3.5L20 15' }],
    ['path', { d: 'M15 15h5v-5' }],
  ],
  clock: [
    ['circle', { cx: '12', cy: '12', r: '8.5' }],
    ['path', { d: 'M12 7.5V12l3.2 2' }],
  ],
  ban: [
    ['circle', { cx: '12', cy: '12', r: '8.5' }],
    ['path', { d: 'M6.2 17.8 17.8 6.2' }],
  ],
  percent: [
    ['path', { d: 'M19 5 5 19' }],
    ['circle', { cx: '7.5', cy: '7.5', r: '2.6' }],
    ['circle', { cx: '16.5', cy: '16.5', r: '2.6' }],
  ],
  gauge: [
    ['path', { d: 'M3.6 17a8.4 8.4 0 1 1 16.8 0' }],
    ['path', { d: 'M12 17l4.2-5.4' }],
  ],
  bulb: [
    ['path', { d: 'M9.4 17.5h5.2M10 20.5h4' }],
    [
      'path',
      { d: 'M12 3a6 6 0 0 1 3.6 10.8c-.5.4-.8 1-.8 1.7H9.2c0-.7-.3-1.3-.8-1.7A6 6 0 0 1 12 3z' },
    ],
  ],
  flag: [
    ['path', { d: 'M5 3v18' }],
    ['path', { d: 'M5 4.6h11l-1.4 3.4L16 11.4H5' }],
  ],
  target: [
    ['circle', { cx: '12', cy: '12', r: '8.6' }],
    ['circle', { cx: '12', cy: '12', r: '4.2' }],
    ['circle', { cx: '12', cy: '12', r: '1' }],
  ],
  forecast: [
    ['path', { d: 'M3 16.5l5-6 4 3 5-7' }],
    ['path', { d: 'M17 6.5h4v4' }],
    ['path', { d: 'M3 21h18' }],
  ],
  repeat: [
    ['path', { d: 'M4 9.5A5 5 0 0 1 9 4.5h9' }],
    ['path', { d: 'M15.2 2 18.5 4.5 15.2 7' }],
    ['path', { d: 'M20 14.5a5 5 0 0 1-5 5H6' }],
    ['path', { d: 'M8.8 17 5.5 19.5 8.8 22' }],
  ],
  sigma: [['path', { d: 'M17.5 5H7l5 7-5 7h10.5' }]],
  checklist: [
    ['path', { d: 'M3.5 6.5 5.5 8.5 9 5' }],
    ['path', { d: 'M3.5 17.5 5.5 19.5 9 16' }],
    ['path', { d: 'M12.5 7h8M12.5 18h8' }],
  ],
  stopwatch: [
    ['circle', { cx: '12', cy: '13.6', r: '7.4' }],
    ['path', { d: 'M12 10.2v3.4l2.4 1.6' }],
    ['path', { d: 'M9.6 3.2h4.8M12 3.2v2.9' }],
  ],
  chevronDown: [['path', { d: 'M6 9.5l6 6 6-6' }]],
  pencil: [['path', { d: 'M4.5 19.5h4L20 8l-4-4L4.5 15.5v4z' }]],
  arrowRight: [['path', { d: 'M5 12h13M13 6l6 6-6 6' }]],
  sortUp: [['path', { d: 'M12 5v14M6 11l6-6 6 6' }]],
  sortDown: [['path', { d: 'M12 19V5M6 13l6 6 6-6' }]],
  info: [
    ['circle', { cx: '12', cy: '12', r: '9' }],
    ['path', { d: 'M12 11v5M12 8h.01' }],
  ],
  loader: [
    [
      'path',
      {
        d: 'M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8',
      },
    ],
  ],
  signin: [
    ['path', { d: 'M14 3.5h4.5a1.5 1.5 0 0 1 1.5 1.5v14a1.5 1.5 0 0 1-1.5 1.5H14' }],
    ['path', { d: 'M4 12h9.5M10 8.5 13.5 12 10 15.5' }],
  ],
  signout: [
    ['path', { d: 'M10 3.5H5.5A1.5 1.5 0 0 0 4 5v14a1.5 1.5 0 0 0 1.5 1.5H10' }],
    ['path', { d: 'M20 12h-9.5M14 8.5 17.5 12 14 15.5' }],
  ],
  monitor: [
    ['rect', { x: '3', y: '4.5', width: '18', height: '12', rx: '2' }],
    ['path', { d: 'M9 20h6M12 16.5V20' }],
  ],
  device: [
    ['rect', { x: '7', y: '3', width: '10', height: '18', rx: '2.2' }],
    ['path', { d: 'M10.8 5.8h2.4' }],
  ],
  eye: [
    ['path', { d: 'M2.5 12S6 5.8 12 5.8 21.5 12 21.5 12S18 18.2 12 18.2 2.5 12 2.5 12z' }],
    ['circle', { cx: '12', cy: '12', r: '3' }],
  ],
  eyeOff: [
    ['path', { d: 'M4 4l16 16' }],
    ['path', { d: 'M9.6 6.2A9.9 9.9 0 0 1 12 5.8c6 0 9.5 6.2 9.5 6.2a17 17 0 0 1-2.7 3.4' }],
    ['path', { d: 'M6.4 8.1A17 17 0 0 0 2.5 12S6 18.2 12 18.2c1 0 1.9-.2 2.7-.4' }],
    ['path', { d: 'M9.9 9.9a3 3 0 0 0 4.2 4.2' }],
  ],
  trash: [
    ['path', { d: 'M4.5 7h15M9.5 7V4.5h5V7' }],
    ['path', { d: 'M6.5 7l1 13h9l1-13' }],
    ['path', { d: 'M10.5 10.5v6M13.5 10.5v6' }],
  ],
  phone: [
    [
      'path',
      {
        d: 'M6.5 3.5h3l1.6 4-2 1.4a10 10 0 0 0 5.6 5.6l1.4-2 4 1.6v3a2 2 0 0 1-2.2 2A16.5 16.5 0 0 1 4.5 5.7a2 2 0 0 1 2-2.2z',
      },
    ],
  ],
  funnel: [['path', { d: 'M3.5 4.5h17l-6.5 8v7l-4-2.2v-4.8l-6.5-8z' }]],
  globe: [
    ['circle', { cx: '12', cy: '12', r: '8.6' }],
    ['path', { d: 'M3.6 9.6h16.8M3.6 14.4h16.8' }],
    [
      'path',
      {
        d: 'M12 3.4c-2.4 2.4-3.6 5.4-3.6 8.6s1.2 6.2 3.6 8.6c2.4-2.4 3.6-5.4 3.6-8.6S14.4 5.8 12 3.4z',
      },
    ],
  ],
  key: [
    ['circle', { cx: '8', cy: '12', r: '3.6' }],
    ['path', { d: 'M11.6 12H21M17.5 12v3.2M20 12v2.4' }],
  ],
  dots: [
    ['circle', { cx: '12', cy: '5.5', r: '1.4' }],
    ['circle', { cx: '12', cy: '12', r: '1.4' }],
    ['circle', { cx: '12', cy: '18.5', r: '1.4' }],
  ],
  star: [
    [
      'path',
      { d: 'M12 3.6l2.7 5.6 6.1.9-4.4 4.3 1 6.1-5.4-2.9-5.4 2.9 1-6.1L3.2 10.1l6.1-.9L12 3.6z' },
    ],
  ],
  shield: [
    ['path', { d: 'M12 3.2 5 5.8v5.4c0 4.2 3 7.6 7 9.6 4-2 7-5.4 7-9.6V5.8L12 3.2z' }],
    ['path', { d: 'M9 12l2.2 2.2L15.2 10' }],
  ],
} satisfies Record<string, IconElement[]>;

export type IconName = keyof typeof iconPaths;
